import React from 'react';
import { Banknote, Landmark } from 'lucide-react';

export const EftNotice = ({ compact = false }) => (
  <div className={`rounded-xl border border-amber-300 bg-amber-50 text-amber-900 ${compact ? 'p-3' : 'p-4'} space-y-1`} data-testid="eft-only-notice">
    <p className="flex items-center gap-2 font-semibold text-sm">
      <Banknote className="w-4 h-4 shrink-0" /> EFT payments only. We do not accept cash.
    </p>
    <p className="flex items-center gap-2 text-xs sm:text-sm" data-testid="bank-details-note">
      <Landmark className="w-4 h-4 shrink-0" /> Bank details will be supplied by the IT Administrator.
    </p>
  </div>
);
